<template>
  <div class="file-upload-container">
    <div  v-loading="isLoading" class="p-4 mt-8 w-full bg-white">
      <div class="flex flex-wrap flex-row justify-between w-full bg-white p-8">
        <div class="files flex flex-wrap flex-row justify-start w-full bg-white p-8">
          <div class="p-1" v-for="config in dataFilesConfig" :key="config.name">
            <MerchantFileUpload
              ref="merchantFiles"
              fileType=".csv, .xls, .xlsx"
              :placeholder="config.label"
              :name="config.value"
              :viewType="'text'"
              @fileInput="handleFileInputChange"
            ></MerchantFileUpload>
          </div>
        </div>
        <el-button
          class="upload w-50 m-auto block"
          type="primary"
          :disabled="disableUploadButton"
          @click="uploadMerchantFiles">Upload
        </el-button>
      </div>
    </div>
    <div class="p-4 mt-8 w-full bg-white">
      <UploadedFiles />
    </div>
  </div>
</template>

<script>
import MerchantFileUpload from '../components/MerchantFileUpload.vue';
import { DATA_FILES_CONFIG } from '../constants';
import UploadedFiles from '../components/UploadedFiles.vue';

export default {
  name: 'MerchantFiles',
  data() {
    return {
      dataFiles: {},
      dataFilesConfig: DATA_FILES_CONFIG,
      disableUploadButton: true,
      isLoading: false,
    };
  },
  methods: {
    clearFiles() {
      const { merchantFiles } = this.$refs;
      merchantFiles.forEach((merchantFile) => {
        const merchantFileProps = merchantFile;

        // clear input file data
        merchantFileProps.file = {};
        merchantFileProps.fileName = '';
      });
    },
    handleFileInputChange({ name, file }) {
      if (file) {
        this.dataFiles[name] = file;
        this.disableUploadButton = false;
      }
    },
    async uploadMerchantFiles() {
      this.isLoading = true;
      try {
        await this.$store.dispatch(
          'MerchantFiles/merchantFileUploads',
          { files: this.dataFiles },
        );
        this.isLoading = false;
        this.$notify({
          title: 'Success',
          message: 'File Upload Was successful',
          type: 'success',
        });
      } catch (e) {
        this.isLoading = false;
      }
      this.isLoading = false;
      this.clearFiles();
    },
  },
  components: {
    MerchantFileUpload,
    UploadedFiles,
  },
  mounted() {
    this.setBreadCrumbs(this.$route.meta.breadCrumbs);
  },
};
</script>

<style scoped lang="scss">
  .files {
    flex: 0 1 90%
  }

  .upload {
    flex: 0 1 5%;
  }
</style>
